// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-input-range {
  position: relative;
  width: 100%;
  margin: 15px 0;
  border-radius: 12px;
  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.2);
  padding: 1px;
  background: var(--sebrae-white);
  transition: all 0.3s ease-in-out;
}
.custom-input-range .input-range {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background: var(--sebrae-white);
  color: #617385;
}
.custom-input-range .input-range label {
  font-family: var(--font-lato);
  font-size: 16px;
  font-weight: 700;
  line-height: 23px;
  margin-bottom: 15px;
}
.custom-input-range .input-range input {
  width: 100%;
  appearance: none;
  outline: none;
  margin: 0;
  outline: 0;
  height: 3px;
  border-radius: 10px;
  background: var(--sebrae-light-gray-2);
  outline: none;
  cursor: pointer;
}
.custom-input-range .input-range input::-webkit-slider-runnable-track {
  display: flex;
  align-items: center;
  position: relative;
  height: 3px;
  border-radius: 10px;
  background: var(--sebrae-light-gray-2);
}
.custom-input-range .input-range input::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background-color: var(--sebrae-blue);
  transform: translateY(-6px);
  cursor: inherit;
}
.custom-input-range .input-range input::-moz-range-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: var(--sebrae-blue);
  cursor: inherit;
  border: none;
}
.custom-input-range .input-range__wrapper-input {
  position: relative;
  width: 100%;
  padding: 25px 0;
  display: flex;
  align-items: center;
}
.custom-input-range .input-range__wrapper-input small {
  font-family: var(--font-lato);
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
  line-height: 1;
  color: #617385;
  position: absolute;
  bottom: 0;
}
.custom-input-range .input-range__wrapper-input small:first-of-type {
  left: 0;
}
.custom-input-range .input-range__wrapper-input small:last-of-type {
  right: 0;
}
.custom-input-range .input-range__wrapper-input .label-value {
  position: absolute;
  left: 0;
  z-index: 1;
  top: 0;
  font-family: var(--font-lato);
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  display: flex;
  align-items: center;
}
.custom-input-range.has-value {
  background: linear-gradient(to right, #3b4aff 0%, #40bbff 100%);
}
.custom-input-range.has-value .input-range {
  color: var(--sebrae-blue);
}`, "",{"version":3,"sources":["webpack://./src/components/input-range/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,6CAAA;EACA,YAAA;EACA,+BAAA;EACA,gCAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EAEA,+BAAA;EACA,cAAA;AAAJ;AAEI;EAEI,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,iBAAA;EACA,mBAAA;AAFN;AAII;EACE,WAAA;EAEA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,eAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,sCAAA;AAFR;AAIM;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,2BAAA;EACA,eAAA;AAFR;AAIM;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,eAAA;EACA,YAAA;AAFR;AAKI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAHN;AAKM;EAEI,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EAEF,cAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;AALR;AAOQ;EACE,OAAA;AALV;AAOQ;EACE,QAAA;AALV;AAQM;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,MAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,cAAA;EACA,aAAA;EACA,mBAAA;AARR;AAYE;EACE,+DAAA;AAVJ;AAYI;EACE,yBAAA;AAVN","sourcesContent":[".custom-input-range {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 15px 0;\r\n  border-radius: 12px;\r\n  box-shadow: 0 1px 4px 0 rgba(20, 46, 82, 0.20);\r\n  padding: 1px;\r\n  background: var(--sebrae-white);\r\n  transition: all .3s ease-in-out;\r\n\r\n  .input-range {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n    width: 100%;\r\n    padding: 16px;\r\n    border-radius: 12px;\r\n\r\n    background: var(--sebrae-white);\r\n    color: #617385;\r\n\r\n    label {\r\n      font: {\r\n        family: var(--font-lato);\r\n        size: 16px;\r\n        weight: 700;\r\n      }\r\n      line-height: 23px;\r\n      margin-bottom: 15px;\r\n    }\r\n    input {\r\n      width: 100%;\r\n      -webkit-appearance: none;\r\n      appearance: none;\r\n      outline: none;\r\n      margin: 0;\r\n      outline: 0;\r\n      height: 3px;\r\n      border-radius: 10px;\r\n      background: var(--sebrae-light-gray-2);\r\n      outline: none;\r\n      cursor: pointer;\r\n\r\n      &::-webkit-slider-runnable-track {\r\n        display: flex;\r\n        align-items: center;\r\n        position: relative;\r\n        height: 3px;\r\n        border-radius: 10px;\r\n        background: var(--sebrae-light-gray-2);\r\n      }\r\n      &::-webkit-slider-thumb {\r\n        -webkit-appearance: none;\r\n        appearance: none;\r\n        width: 16px;\r\n        height: 16px;\r\n        border-radius: 50%;\r\n        border: none;\r\n        background-color: var(--sebrae-blue);\r\n        transform: translateY(-6px);\r\n        cursor: inherit;\r\n      }\r\n      &::-moz-range-thumb {\r\n        appearance: none;\r\n        width: 16px;\r\n        height: 16px;\r\n        border-radius: 50%;\r\n        background-color: var(--sebrae-blue);\r\n        cursor: inherit;\r\n        border: none;\r\n      }\r\n    }\r\n    &__wrapper-input {\r\n      position: relative;\r\n      width: 100%;\r\n      padding: 25px 0;\r\n      display: flex;\r\n      align-items: center;\r\n\r\n      small {\r\n        font: {\r\n          family: var(--font-lato);\r\n          size: 11px;\r\n          style: italic;\r\n          weight: 400;\r\n        }\r\n        line-height: 1;\r\n        color: #617385;\r\n        position: absolute;\r\n        bottom: 0;\r\n\r\n        &:first-of-type {\r\n          left: 0;\r\n        }\r\n        &:last-of-type {\r\n          right: 0;\r\n        }\r\n      }\r\n      .label-value {\r\n        position: absolute;\r\n        left: 0;\r\n        z-index: 1;\r\n        top: 0;\r\n        font: {\r\n          family: var(--font-lato);\r\n          size: 13px;\r\n          weight: 400;\r\n        }\r\n        line-height: 1;\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n    }\r\n  }\r\n  &.has-value {\r\n    background: linear-gradient(to right, #3b4aff 0%,#40bbff 100%);\r\n\r\n    .input-range {\r\n      color: var(--sebrae-blue);\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
